export interface PeriodOption {
  title: string;
  shortTitle: string;
  value: string;
  sharpCharts2Id: string;
  isIntraday: boolean;
  isPayingMemberOnly: boolean;
  isProOnly: boolean;
  isCryptoOnly: boolean;
  isNonCryptoOnly: boolean;
  dividerAbove: boolean;
  dividerBelow: boolean;
}

export const PERIOD_OPTION_HOURLY: PeriodOption = {
  title: 'Hourly',
  shortTitle: 'Hourly',
  value: 'hourly',
  sharpCharts2Id: '60',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_DAILY: PeriodOption = {
  title: 'Daily',
  shortTitle: 'Daily',
  value: 'daily',
  sharpCharts2Id: 'D',
  isIntraday: false,
  isPayingMemberOnly: false,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_WEEKLY: PeriodOption = {
  title: 'Weekly',
  shortTitle: 'Weekly',
  value: 'weekly',
  sharpCharts2Id: 'W',
  isIntraday: false,
  isPayingMemberOnly: false,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_MONTHLY: PeriodOption = {
  title: 'Monthly',
  shortTitle: 'Monthly',
  value: 'monthly',
  sharpCharts2Id: 'M',
  isIntraday: false,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_QUARTERLY: PeriodOption = {
  title: 'Quarterly',
  shortTitle: 'Quarterly',
  value: 'quarterly',
  sharpCharts2Id: 'Q',
  isIntraday: false,
  isPayingMemberOnly: true,
  isProOnly: true,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_YEARLY: PeriodOption = {
  title: 'Yearly',
  shortTitle: 'Yearly',
  value: 'yearly',
  sharpCharts2Id: 'Y',
  isIntraday: false,
  isPayingMemberOnly: true,
  isProOnly: true,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: true
};
export const PERIOD_OPTION_ONE_MIN: PeriodOption = {
  title: '1 min',
  shortTitle: '1 min',
  value: '1 min',
  sharpCharts2Id: '1',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_TWO_MIN: PeriodOption = {
  title: '2 min',
  shortTitle: '2 min',
  value: '2 min',
  sharpCharts2Id: '2',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_THREE_MIN: PeriodOption = {
  title: '3 min',
  shortTitle: '3 min',
  value: '3 min',
  sharpCharts2Id: '3',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_FIVE_MIN: PeriodOption = {
  title: '5 min',
  shortTitle: '5 min',
  value: '5 min',
  sharpCharts2Id: '5',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_TEN_MIN: PeriodOption = {
  title: '10 min',
  shortTitle: '10 min',
  value: '10 min',
  sharpCharts2Id: '10',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_FIFTEEN_MIN: PeriodOption = {
  title: '15 min',
  shortTitle: '15 min',
  value: '15 min',
  sharpCharts2Id: '15',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_THIRTY_MIN: PeriodOption = {
  title: '30 min',
  shortTitle: '30 min',
  value: '30 min',
  sharpCharts2Id: '30',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_SIXTY_MIN: PeriodOption = {
  title: '60 min',
  shortTitle: '60 min',
  value: '60 min',
  sharpCharts2Id: '60',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_TWO_HOUR: PeriodOption = {
  title: '120 min (2 hours)',
  shortTitle: '120 min',
  value: '120 min (2 hours)',
  sharpCharts2Id: '120',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_FOUR_HOUR: PeriodOption = {
  title: '240 min (4 hours)',
  shortTitle: '240 min',
  value: '240 min (4 hours)',
  sharpCharts2Id: '240',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: true,
  isNonCryptoOnly: false,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_THIRTY_NINE_MIN: PeriodOption = {
  title: '39 min (10 bars/day)',
  shortTitle: '39 min',
  value: '10 bars/day',
  sharpCharts2Id: '39',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: true,
  dividerAbove: true,
  dividerBelow: false
};
export const PERIOD_OPTION_SIXTY_FIVE_MIN: PeriodOption = {
  title: '65 min (6 bars/day)',
  shortTitle: '65 min',
  value: '6 bars/day',
  sharpCharts2Id: '65',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: true,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_SEVENTY_EIGHT_MIN: PeriodOption = {
  title: '78 min (5 bars/day)',
  shortTitle: '78 min',
  value: '5 bars/day',
  sharpCharts2Id: '78',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: true,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_ONE_HUNDRED_THIRTY_MIN: PeriodOption = {
  title: '130 min (3 bars/day)',
  shortTitle: '130 min',
  value: '3 bars/day',
  sharpCharts2Id: '130',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: true,
  dividerAbove: false,
  dividerBelow: false
};
export const PERIOD_OPTION_ONE_HUNDRED_NINETY_FIVE_MIN: PeriodOption = {
  title: '195 min (2 bars/day)',
  shortTitle: '195 min',
  value: '2 bars/day',
  sharpCharts2Id: '195',
  isIntraday: true,
  isPayingMemberOnly: true,
  isProOnly: false,
  isCryptoOnly: false,
  isNonCryptoOnly: true,
  dividerAbove: false,
  dividerBelow: false
};

export const DEFAULT_PERIOD_OPTION: PeriodOption = PERIOD_OPTION_DAILY;

export const PERIOD_OPTIONS_ARRAY = [
  PERIOD_OPTION_HOURLY,
  PERIOD_OPTION_DAILY,
  PERIOD_OPTION_WEEKLY,
  PERIOD_OPTION_MONTHLY,
  PERIOD_OPTION_QUARTERLY,
  PERIOD_OPTION_YEARLY,
  PERIOD_OPTION_ONE_MIN,
  PERIOD_OPTION_TWO_MIN,
  PERIOD_OPTION_THREE_MIN,
  PERIOD_OPTION_FIVE_MIN,
  PERIOD_OPTION_TEN_MIN,
  PERIOD_OPTION_FIFTEEN_MIN,
  PERIOD_OPTION_THIRTY_MIN,
  PERIOD_OPTION_SIXTY_MIN,
  PERIOD_OPTION_TWO_HOUR,
  PERIOD_OPTION_FOUR_HOUR,
  PERIOD_OPTION_THIRTY_NINE_MIN,
  PERIOD_OPTION_SIXTY_FIVE_MIN,
  PERIOD_OPTION_SEVENTY_EIGHT_MIN,
  PERIOD_OPTION_ONE_HUNDRED_THIRTY_MIN,
  PERIOD_OPTION_ONE_HUNDRED_NINETY_FIVE_MIN
];

export function getPeriodOptionFromPeriodValue(periodValue: string) {
  return PERIOD_OPTIONS_ARRAY.find(p => p.value === periodValue) ?? DEFAULT_PERIOD_OPTION;
}
